<template>
  <div class="receipt">
    <div class="paper">
      <hr />
      <h1>{{ sucursalInfo.NOMBRE }}</h1>
      <div class="event">
        {{ sucursalInfo.DIRECCION }} {{ sucursalInfo.COLONIA }} CP:{{ sucursalInfo.CODIGO_POSTAL }}
      </div>
      <div class="event">{{ sucursalInfo.MUNICIPIO }} {{ sucursalInfo.ESTADO }}</div>
      <div class="event">{{ sucursalInfo.TELEFONO }} {{ sucursalInfo.CELULAR }}</div>

      <TicketPrincipalEnvio v-if="infoEnvioActual.tipoEnvio" />
      <TicketAbonoSencillo v-if="objetoDatosAbonoSencillo.IdEnvio" />
      <TicketAbonoMultiple v-if="objetoDatosMultiple.Fecha" />
      <TicketCDR v-if="objetoDatosCambioDireccion.IdEnvio" />
      <TicketCorteDeCaja v-if="objetoDatosImprimirTicketCorteDeCaja.dineroActualEnCaja>=0" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import TicketCDR from "@/components/tickets/TicketCambioDeDireccion.vue";
import TicketAbonoMultiple from "@/components/tickets/TicketAbonoMultiple.vue";
import TicketAbonoSencillo from "@/components/tickets/TicketAbonoSencillo.vue";
import TicketPrincipalEnvio from "@/components/tickets/TicketPrincipalEnvio.vue";
import TicketCorteDeCaja from "@/components/tickets/TicketCorteDeCaja.vue";
export default {
  name: "TicketDeCompra",
  async beforeMount() {
    await this.getSucursalEnLaQueEstoy(this.logedInUserInfo.sucursal);
  },
  data: () => ({}),
  methods: {
    ...mapActions("sesion", ["getSucursalEnLaQueEstoy"])
  },
  components: {
    TicketCDR,
    TicketAbonoMultiple,
    TicketAbonoSencillo,
    TicketPrincipalEnvio,
    TicketCorteDeCaja
  },
  computed: {
    ...mapState("enviosInfoEnvio", {
      infoEnvioActual: state => state.infoEnvio,
      infoEnvioGeneradaDespues: state => state.infoEnvioGeneradaDespues
    }),
    ...mapState("abonosEnvios", {
      objetoDatosAbonoSencillo: state => state.objetoDatosAbonoSencillo,
      objetoDatosMultiple: state => state.objetoDatosMultiple,
      objetoDatosCambioDireccion: state => state.objetoDatosCambioDireccion,
      objetoDatosImprimirTicketCorteDeCaja: state => state.objetoDatosImprimirTicketCorteDeCaja,
    }),
    ...mapState("sesion", {
      sucursalInfo: state => state.sucursalData,
      logedInUserInfo: state => state.logedInUserInfo
    })
  }
};
</script>

<style lang="css" scoped>
* {
  font-size: 18px/1.5;
  font-family: 'Roboto', sans-serif;
  box-sizing: border-box;
  align-items: left;
  letter-spacing: -2px;
  line-height: 0.9;
}
body {
  display: flex;
  height: 100vh;
  margin: 0;
  justify-content: center;
  align-items: left;
  font-size: 12px;
}
.receipt {
  align-items: left;
  word-break: break-word;
  width: 302px;
  border: 1px dotted black;
  border-width: 1px 0;
}
.receipt .paper {
  background: white;
  text-align: left;
}
.receipt h1 {
  font-size: 150%;
  margin: 0;
}
.receipt h1,
.receipt .event {
  text-align: center;
  line-height: 1;
}
.receipt dl {
  display: flex;
  flex-wrap: wrap;
  margin: 1.5em 0 0;
}
.receipt dt,
.receipt dd {
  margin: 0;
  width: 50%;
}
.receipt dd {
  text-align: right;
}
.receipt .total {
  margin: 0;
}
.receipt .total:before {
  display: block;
  width: 100%;
  text-align: right;
}
.receipt .total dt {
  text-align: right;
}
.receipt .total dd {
  padding-left: 0.5em;
  text-align: left;
}
</style>
